import BankAccountInfomationTab from './BankAccountInfomationTab.vue';

export default BankAccountInfomationTab;
